import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Grid,
  Switch,
  FormControlLabel,
  Card,
  CardContent,
  Avatar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Icons } from "../doctor-console/Utils/iconsRegistry";
import { normalizeBase64Image } from "../utils/utils";
import CustomDoctorScheduleModal from "../hlthtek-admin-demo/DoctorScheduling/CustomDoctorScheduleModal";
import DoctorSlotsModal from "../hlthtek-admin-demo/DoctorScheduling/DoctorSlotsModal";
import PaymentModal from "./PaymentModal";

const CreateAppointment = ({
  isPatientOpen,
  handleClose,
  handleSubmit2,
  onSubmitSearch,
  register2,
  searchType,
  patients,
  selectedPatId,
  handleCardSelect,
  handleSubmit,
  appointmentSubmit,
  register,
  doctorId,
  doctorsList,
  errors,
  roleType,
  setselectedEmailId,
  appointmentModal,
  onPaymentModalClose = () => {},
  // departmentId,
}) => {
  console.log("Doctors List", doctorsList);
  console.log("doctorId", doctorId);

  const [collectPayment, setCollectPayment] = useState(false);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [createdAppointment, setCreatedAppointment] = useState(null);

  const selectedDoctorData =
    (doctorsList || []).find((doctor) => doctor.doctor_id === doctorId) || null;

  const handlePaymentModalClose = () => {
    console.log("[CreateAppointment] PaymentModal onClose called");
    setIsPaymentOpen(false);
  };

  const onCreateAppointment = async (data, event) => {
    try {
      console.log("[CreateAppointment] onCreateAppointment called", {
        data,
        collectPayment,
        selectedPatId,
        doctorId,
      });
      const res = await appointmentSubmit(data, event);
      console.log("[CreateAppointment] appointmentSubmit response:", res);
      if (res && typeof res === "object" && (res.status || "").toString().toLowerCase() === "success") {
        console.log("[CreateAppointment] Appointment created successfully with id:", res.appointment_id);
        if (collectPayment) {
          console.log("[CreateAppointment] collectPayment is ON. Opening PaymentModal...");
          const appt = {
            appointment_id: res.appointment_id,
            patient: selectedPatId,
            payment_status: "",
          };
          setCreatedAppointment(appt);
          console.log("[CreateAppointment] createdAppointment prepared:", appt);
          setIsPaymentOpen(true);
          console.log("[CreateAppointment] isPaymentOpen set to true");
        } else {
          console.log("[CreateAppointment] collectPayment is OFF. Skipping PaymentModal.");
        }
      } else {
        console.log("[CreateAppointment] Appointment create failed or unexpected response:", res);
      }
    } catch (e) {
      console.error("Create appointment failed", e);
    }
  };

 
  return (
    <>
      <style>
        {`
          .patient-name {
            font-size: 1.1rem !important;
          }
          .patient-detail {
            font-size: 0.875rem !important;
          }
          @media (min-width: 768px) {
            .patient-name {
              font-size: 1.25rem !important;
            }
          }
          @media (max-width: 576px) {
            .appointment-modal .modal-body {
              padding: 15px;
            }
            .form-group {
              margin-bottom: 15px;
            }
            .btn {
              width: 100%;
              margin-bottom: 10px;
            }
          }
        `}
      </style>

      <Dialog
        open={isPatientOpen || appointmentModal}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            width: "90%", // responsive width (mobile-friendly)
            maxWidth: "1000px", // never exceed 1000px
            height: "80vh", // 80% of screen height
            zIndex: 9997,
          },
        }}
      >
        <DialogTitle
          sx={{
            // backgroundImage: `url(${Icons.modal_blue})`,
            backgroundColor: "#213360",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            className="main-title"
            style={{
              textAlign: "center",
              color: "#FFFFFF",
              margin: "0px",
              fontSize: "20px",
            }}
          >
            Make an Appointment
          </div>
          <IconButton onClick={handleClose}>
            <CloseIcon
              sx={{
                color: "#FFFFFF",
                fontSize: { xs: "1.2rem", sm: "1.5rem" },
              }}
            />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{ p: 0, maxHeight: "calc(80vh - 100px)", overflowY: "auto" }}
        >
          <div className="contact-panel">
            {/* Search form */}
            <form onSubmit={handleSubmit2(onSubmitSearch)}>
              <div className="row">
                <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                  <div className="form-group">
                    <label htmlFor="searchType">Search By</label>
                    <select
                      className="form-control"
                      name="searchType"
                      {...register2("searchType")}
                    >
                      <option value="abhaId">ABHA Address</option>
                      <option value="abhaNo">ABHA No</option>
                      <option value="phoneNo">Phone No</option>
                      <option value="demographics">Demographics</option>
                    </select>
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                  <div className="form-group">
                    <label htmlFor="searchQuery">Enter Search Query</label>
                    <input
                      disabled={searchType === "demographics"}
                      type="text"
                      className="form-control"
                      placeholder="Enter your search query"
                      name="searchQuery"
                      {...register2("searchQuery")}
                    />
                  </div>
                </div>

                {/* Demographics input fields */}
                <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                      disabled={searchType !== "demographics"}
                      type="text"
                      className="form-control"
                      placeholder="Enter patient name"
                      name="name"
                      {...register2("name")}
                    />
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                  <div className="form-group">
                    <label htmlFor="gender">Gender</label>
                    <select
                      className="form-control"
                      disabled={searchType !== "demographics"}
                      name="gender"
                      {...register2("gender")}
                    >
                      <option value="">Select Gender</option>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                      <option value="O">Other</option>
                    </select>
                  </div>
                </div>

                <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                  <div className="form-group form-group-date">
                    <label htmlFor="dob">Date of Birth</label>
                    <i
                      className="icon-calendar form-group-icon"
                      style={{
                        marginTop: "24px",
                        // backgroundColor:
                        //   searchType !== "demographics" ? "#e9ecef" : "#fff",
                      }}
                    ></i>
                    <input
                      disabled={searchType !== "demographics"}
                      type="date"
                      className="form-control"
                      name="dob"
                      {...register2("dob")}
                    />
                  </div>
                </div>

                <div className="col-6 mx-auto">
                  <button
                    type="submit"
                    className="btn btn__secondary btn__rounded btn__block mt-6"
                    style={{ marginBottom: "20px" }}
                  >
                    Search
                  </button>
                </div>
              </div>
            </form>

            {/* Patient search results */}
            {patients && patients.length > 0 && (
              <form>
                <div className="row">
                  {patients.map((patient, index) => (
                    <div className="col-12 col-md-6 col-lg-6 mb-3" key={index}>
                      <Card
                        style={{
                          marginBottom: "20px",
                          border:
                            selectedPatId === patient.patient_id
                              ? "2px solid #21cdc0"
                              : "none",
                          minHeight: "200px",
                          height: "auto",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleCardSelect(patient.patient_id);
                          setselectedEmailId(patient.email || "");
                        }}
                      >
                        <CardContent>
                          <div
                            className="d-flex flex-column flex-md-row align-items-start align-items-md-center"
                            style={{
                              gap: "15px",
                            }}
                          >
                            <Avatar
                              alt={patient.name}
                              src={normalizeBase64Image(patient.photo)}
                              className="mx-auto mx-md-0 mb-2 mb-md-0"
                              sx={{ width: 60, height: 60 }}
                            />
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <Typography
                                variant="h6"
                                className="patient-name"
                                style={{
                                  marginBottom: "8px",
                                  wordBreak: "break-word",
                                }}
                              >
                                {patient.name}
                              </Typography>
                              <Typography
                                variant="body2"
                                className="patient-detail"
                                style={{
                                  marginBottom: "4px",
                                  wordBreak: "break-word",
                                }}
                              >
                                ABHA Number: {patient.abha_no || "-"}
                              </Typography>
                              <Typography
                                variant="body2"
                                className="patient-detail"
                                style={{
                                  marginBottom: "4px",
                                  wordBreak: "break-word",
                                }}
                              >
                                Patient ID: {patient.patient_id}
                              </Typography>
                              <Typography
                                variant="body2"
                                className="patient-detail"
                                style={{
                                  marginBottom: "4px",
                                  wordBreak: "break-word",
                                }}
                              >
                                ABHA Address: {patient.abha_id || "-"}
                              </Typography>
                              <Typography
                                variant="body2"
                                className="patient-detail"
                                style={{
                                  marginBottom: "4px",
                                }}
                              >
                                Gender: {patient.gender}
                              </Typography>
                              <Typography
                                variant="body2"
                                className="patient-detail"
                              >
                                DOB: {patient.dob}
                              </Typography>
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                    </div>
                  ))}
                </div>
              </form>
            )}

            {/* Appointment form */}
            <form
              className="contact-panel__form"
              onSubmit={handleSubmit(onCreateAppointment)}
            >
              <div className="row">
                <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                  {/* {roleType !== "doctor" && ( */}
                  <div>
                    <label>Selected Doctor</label>
                    <div className="form-group">
                      <i className="icon-news form-group-icon"></i>
                      <select
                        disabled
                        className="form-control"
                        name="doctor_id"
                        {...register("doctor_id")}
                        value={doctorId}
                      >
                        {doctorId && doctorsList && (
                          <option value={doctorId}>
                            {
                              doctorsList.find(
                                (doctor) => doctor.doctor_id === doctorId
                              )?.name
                            }
                          </option>
                        )}
                      </select>
                      <input type="hidden" name="doctor_id" value={doctorId} />
                      {errors.doctor_id && (
                        <p className="errorMsg" style={{ color: "red" }}>
                          {errors.doctor_id.message}
                        </p>
                      )}
                    </div>
                  </div>
                  {/* )} */}
                </div>

                <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                  <label> Appointment Start Time</label>
                  <div className="form-group">
                    <input
                      disabled
                      type="datetime-local"
                      className="form-control"
                      placeholder="Enter Appointment Start Time"
                      name="appointment_start_time"
                      {...register("appointment_start_time", {
                        required: "Appointment Start Time is required.",
                      })}
                    />
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                  <label> Appointment End Time</label>
                  <div className="form-group">
                    <input
                      disabled
                      type="datetime-local"
                      className="form-control"
                      placeholder="Enter Appointment End Time"
                      name="appointment_end_time"
                      {...register("appointment_end_time", {
                        required: "Appointment End Time is required.",
                      })}
                    />
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                  <label>Select a mode of appointment</label>
                  <div className="form-group">
                    <i className="icon-news form-group-icon"></i>
                    <select
                      className="form-control"
                      name="appointment_mode"
                      {...register("appointment_mode", {
                        required: "Appointment Mode is required.",
                      })}
                    >
                      <option value="" disabled>
                        Select Appointment Mode
                      </option>
                      <option value="OFFLINE">OFFLINE/F2F</option>
                      <option value="ONLINE">ONLINE</option>
                    </select>
                  </div>
                </div>

                <div className="col-12 d-flex justify-content-center align-items-center">
                  <FormControlLabel
                    control={
                      <Switch
                        checked={collectPayment}
                        onChange={(e) => {
                          console.log("[CreateAppointment] collectPayment toggled:", e.target.checked);
                          setCollectPayment(e.target.checked);
                        }}
                        color="primary"
                      />
                    }
                    label="Collect payment now"
                  />
                </div>

                <div className="col-6 mx-auto">
                  <button
                    type="submit"
                    className="btn btn__secondary btn__rounded btn__block mt-6"
                  >
                    Create appointment
                  </button>
                </div>
              </div>
            </form>
          </div>
        </DialogContent>

      </Dialog>

      <PaymentModal
        open={isPaymentOpen}
        onClose={handlePaymentModalClose}
        onAfterClose={onPaymentModalClose}
        appointment={createdAppointment}
        selectedDoctorData={selectedDoctorData}
        onStatusUpdated={() => {}}
      />
    </>
  );
};

export default CreateAppointment;
